export default __webpack_public_path__ + "static/media/topup_join_as_member_loyalty_bk.cf2da912.png";